import { create } from 'zustand';

const useCandidateStore = create((set, get) => ({
  // State
  candidates: [],
  selectedCandidates: [],
  filters: {},
  loading: false,
  error: null,

  // Actions
  setLoading: (loading) => set({ loading }),
  setError: (error) => set({ error }),
  clearError: () => set({ error: null }),

  // Add specific actions here
}));

export default useCandidateStore;